import {Component, computed, Injectable, Input, signal} from '@angular/core';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {ResourceSearchSchema} from '@middleware';
import {Filter, FilterVisibility} from '../filter';

@Component({
  template: `<ul class="bulletless">
    @for (user of filter.selected(); track user.value) {
      <li
        ><mat-checkbox [value]="user.value" checked="checked" (change)="filter.remove(user.value)">{{
          user.label
        }}</mat-checkbox></li
      >
    }
    <li><input #newUser (keyup.enter)="filter.add(newUser.value)" /></li>
  </ul> `,
  imports: [MatCheckboxModule],
})
class UserList<F extends UserFilter> {
  @Input() filter: F;
}

abstract class UserFilter implements Filter<'Resources'> {
  abstract key;
  abstract label;
  abstract component;
  abstract apply(filterBody: ResourceSearchSchema): void;
  selectedValues = signal<string[]>([]);
  selected = computed(() => this.selectedValues().map(value => ({label: value, value})));
  defaultExpanded = false;
  load(values: string[]): void {
    this.selectedValues.set(values);
  }
  remove(value: string): void {
    this.selectedValues.update(values => values.filter(v => v != value));
  }
  add(value: string): void {
    this.selectedValues.update(values => [...values, value]);
  }
  abstract visibility: FilterVisibility;
}

@Injectable()
export class OwnerFilter extends UserFilter {
  override key = 'owner' as const;
  override label = 'Owner';
  override component = UserList<OwnerFilter>;
  override apply(filterBody: ResourceSearchSchema): void {
    const selected = this.selectedValues();
    if (selected.length == 0) return;
    filterBody.owner = {
      terms: selected,
      match_all: false,
    };
  }
  visibility = FilterVisibility.NOONE;
}

@Injectable()
export class FavoriteFilter extends UserFilter {
  override key = 'favorited_users' as const;
  override label = 'Favorited by';
  override component = UserList<FavoriteFilter>;
  override apply(filterBody: ResourceSearchSchema): void {
    const selected = this.selectedValues();
    if (selected.length == 0) return;
    filterBody.favorited_users = {
      terms: selected,
      match_all: false,
    };
  }
  visibility = FilterVisibility.NOONE;
}
